<template>
    <v-row>
        <div class="col-md-12 home-box">
            <Breadcrumbs :title="'Product Batches'"></Breadcrumbs>
            <BatchListTable></BatchListTable>
            

        </div>
    </v-row>
    
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import BatchListTable from "../../components/batches/BatchListTable.vue";

export default {
    name: 'batchList',
    components:{
        Breadcrumbs,
        BatchListTable
    }
}
</script>